var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "verified-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#11232e",
    d: "M16 1.917c-7.765 0-14.083 6.318-14.083 14.083s6.318 14.083 14.083 14.083c7.765 0 14.083-6.318 14.083-14.083s-6.318-14.083-14.083-14.083zM16 0c8.836 0 16 7.163 16 16s-7.163 16-16 16c-8.836 0-16-7.163-16-16s7.163-16 16-16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a0e9",
    d: "M13.081 23.367l-6.007-6.005c-0.167-0.167-0.271-0.398-0.271-0.654s0.104-0.486 0.271-0.654v0l1.307-1.307c0.167-0.167 0.398-0.271 0.654-0.271s0.486 0.104 0.654 0.271v0l4.046 4.046 8.667-8.667c0.167-0.167 0.398-0.271 0.654-0.271s0.486 0.104 0.654 0.271v0l1.303 1.307c0.167 0.167 0.271 0.398 0.271 0.654s-0.104 0.486-0.271 0.654v0l-10.624 10.626c-0.167 0.167-0.398 0.271-0.654 0.271s-0.486-0.104-0.654-0.271v0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verified-icon.56d22aa4316e150c12252a8bf0fa7ea9.svg";
export { ForwardRef as ReactComponent };